import React, { useState } from "react";
import { useComponentDidMount } from "../../../lib/hook";
import { connect } from "react-redux";
import { fetchExistingCategoryShows, searchShows } from "../../../action_managers/show_search";
import AdvertiserBrowseSearch from "./advertiser_browse_search";

const AdvertiserBrowsePodcasts = props => {
  const [showSearch, setShowSearch] = useState(true);
  return <AdvertiserBrowseSearch show={showSearch} onClose={() => setShowSearch(false)} />;
};

export default connect(
  state => ({ user: state.user.user, categoryShows: state.browsePromotion.categoryShows }),
  { fetchExistingCategoryShows, searchShows }
)(AdvertiserBrowsePodcasts);
